import type { UseFormReturn } from 'react-hook-form'

import React from 'react'
import { FormProvider as Form } from 'react-hook-form'

type FormProviderProps = {
	children: React.ReactNode
	className?: string
	onSubmit(e: React.FormEvent<HTMLFormElement>): void
	methods: UseFormReturn<any>
	id?: string
}
export default function FormProvider({
	children,
	className,
	onSubmit,
	methods,
	id,
}: FormProviderProps) {
	return (
		<Form {...methods}>
			<form id={id} onSubmit={onSubmit} className={className}>
				{children}
			</form>
		</Form>
	)
}
